import { computed, type ComputedRef } from 'vue'
import { useI18n } from 'vue-i18n'

import { resolvePortalLogo } from '@clientportal/auth-layer/utils/branding-assets'

import { useLocation } from '@common/location-layer/composables/useLocation'

/**
 * Switcher sidebar branding context for CPRootContainer.
 */
export function useCPSwitcherSidebar(_currentGroupSlug: ComputedRef<string | null>, _selectedProductId: ComputedRef<string>) {
  const { store: locationStore } = useLocation()
  const { t } = useI18n()

  // Sidebar brand mark is the portal logo (logo -> favicon), never the hero image.
  const portalIcon = computed(() => resolvePortalLogo(locationStore.branding))
  const portalName = computed(() => locationStore.branding?.portalBannerText || t('auth.branding.defaultPortalName'))

  /** Subtitle under portal name in sidebar (location branding). */
  const portalSubtitle = computed(() => {
    const d = locationStore.branding?.portalDescription
    return d && String(d).trim() ? String(d).trim() : ''
  })

  return {
    portalIcon,
    portalName,
    portalSubtitle,
  }
}
